import React from "react";
import "./Loading.css";

const Loading = props => {
  return (
    <div className="Loading load-3">
      <div className="line" />
      <div className="line" />
      <div className="line" />
    </div>
  );
};

export default Loading;
